import AxiosService from '../AxiosService';

const IoPayAuth = async () => {
  const instance = AxiosService.createIoPayAxiosInstance();

  const response = await instance.post(
    `${process.env.IOPAY_API_URL}/v1/card/authentication`,
    {
      email: process.env.IOPAY_EMAIL,
      io_seller_id: process.env.IOPAY_SELLER_ID,
      secret: process.env.IOPAY_SECRET,
    },
  );

  return response.data;
};

const TokenizeCard = async (token: string, data: Object) => {
  const instance = AxiosService.createIoPayAxiosInstance();

  try {
    const response = await instance.post(
      `${process.env.IOPAY_API_URL}/v1/card/tokenize/token`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export default {
  IoPayAuth,
  TokenizeCard,
};
